import { Link } from 'react-router-dom'
import SEO, { breadcrumbs } from '../components/common/SEO'
import PageHero from '../components/common/PageHero'
import Disclosure from '../components/common/Disclosure'
import { Breadcrumbs, BookingBand } from '../components/detail/DetailBlocks'
import { faqGroups, allFaqs, faqSchema, faqReviewed } from '../data/faqs'

const FaqPage = () => {
  const trail = [
    { name: 'Home', path: '/' },
    { name: 'FAQ', path: '/faq' },
  ]

  return (
    <>
      <SEO
        title="FAQ — Booking, Pricing & Insurance"
        description="Answers about booking, first visits, pricing, direct billing, and insurance at Recreo Rehab, Yonge & Eglinton, Midtown Toronto."
        path="/faq"
        noIndex={!faqReviewed}
        structuredData={[breadcrumbs(trail), faqSchema(allFaqs)]}
      />

      <div className="bg-cream-200">
        <PageHero title="Frequently Asked Questions" subtitle="Good to know" texture="sage-noise" size="sm" />
      </div>

      <div className="bg-cream-200">
        <Breadcrumbs items={trail} />
        <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16 space-y-14">
          {faqGroups.map((group) => (
            <div key={group.title}>
              <h2 className="font-display text-dark-700 text-2xl md:text-3xl font-semibold mb-6">
                {group.title}
              </h2>
              <div className="border-b border-dark-300/40">
                {group.items.map((f) => (
                  <Disclosure key={f.id} title={f.q} as="h3">
                    <p className="font-sans text-dark-500 text-base leading-relaxed">{f.a}</p>
                  </Disclosure>
                ))}
              </div>
            </div>
          ))}

          <p className="font-sans text-dark-500 text-base leading-relaxed">
            Still have a question?{' '}
            <Link to="/contact" className="text-brand-orange-600 underline underline-offset-4">
              Get in touch
            </Link>{' '}
            or see{' '}
            <Link to="/visit" className="text-brand-orange-600 underline underline-offset-4">
              how to find us
            </Link>
            .
          </p>
        </section>
      </div>

      <BookingBand />
    </>
  )
}

export default FaqPage
